import {Tag} from '../../../../domain/tag';
import {
  ChangeToApprove,
  ETenantSettingActionType
} from './tenant-setting-change';

export class DeleteTagChangeToApprove extends ChangeToApprove {
  constructor(
    public tag: Tag,
    public message: string
  ) {
    super(tag.id, ETenantSettingActionType.DeleteTag, message);
  }
}

